import React, { useState } from "react";
import { useAuth } from "../../../../contexts/authContext";
import { searchRecordsSong, searchRecordsLabel, addRecord } from "../../../../firebase/db/releases/crud.tsx";
import DatePicker from "react-datepicker";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import "react-datepicker/dist/react-datepicker.css";

const FormModal = ({ isOpen, onClose }) => {
	const { currentUser } = useAuth();
	const [releaseDate, setReleaseDate] = useState(new Date());
	const [songItems, setSongItems] = useState([]);
	const [labelItems, setLabelItems] = useState([]);
	const [songLookup, setSongLookup] = useState(String);
	const [labelLookup, setLabelLookup] = useState(String);
	const [formData, setFormData] = useState({
		id: "",
		created: "",
		is_released_independant: null,
		label: "",
		release_date: new Date(),
		release_id: "",
		song: "",
		user_id: ""
	});

	if (!isOpen) return null;

	const handleClose = () => {
		setFormData();
		onClose();
	};

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		formData.created = new Date();
		formData.user_id = currentUser.uid;
		formData.song = "song/" + songLookup;
		formData.label = "label/" + labelLookup;
		addRecord(formData);
		handleClose();
	};

	const handleOnSelectSong = (item) => {
		setSongLookup(item.id);
	};

	const handleOnSelectLabel = (item) => {
		setLabelLookup(item.id);
	};

	const handleOnClearSong = () => {
		setSongLookup();
	};

	const handleOnClearLabel = () => {
		setLabelLookup();
	};

	const handleOnSearchSong = async (string, results) => {
		const songs = await searchRecordsSong(currentUser, "song_name", string);
		setSongItems(songs);
	};

	const handleOnSearchLabel = async (string, results) => {
		const labels = await searchRecordsLabel(currentUser, "label_name", string);
		setLabelItems(labels);
	};

	const formatResultsSong = (item) => {
		return (
			<>
				<span
					style={{
						display: "block",
						textAlign: "left",
						color: "black",
						backgroundColor: "white",
						padding: "0px",
						zIndex: "4",
						cursor: "pointer",
						margin: "0",
						hoverBackgroundColor: "gray",
						boxShadow: "none",
						lineColor: "black"
					}}>
					Song: {item.name}
				</span>
			</>
		);
	};

	const formatResultsLabel = (item) => {
		return (
			<>
				<span
					style={{
						display: "block",
						textAlign: "left",
						color: "black",
						backgroundColor: "white",
						padding: "0px",
						zIndex: "4",
						cursor: "pointer",
						margin: "0",
						hoverBackgroundColor: "gray",
						boxShadow: "none",
						lineColor: "black"
					}}>
					Label: {item.name}
				</span>
			</>
		);
	};

	return (
		// <div id="extralarge-modal" tabIndex={-1} className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
		<div
			className="fixed inset-0 flex
                        items-center justify-center
                        bg-black bg-opacity-50">
			<div id="medium-modal" className="fixed items-center justify-center z-50 p-4 inset-0 content-center">
				<div className="relative max-w-lg max-h-full mr-auto ml-auto">
					<div className="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
						<div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
							<h3 className="text-xl font-medium text-grey-700">New Release</h3>
							<button
								onClick={handleClose}
								type="button"
								className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
								data-modal-hide="extralarge-modal">
								<svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
									<path
										stroke="currentColor"
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="2"
										d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
									/>
								</svg>
								<span className="sr-only">Close modal</span>
							</button>
						</div>

						<div className="modal-body p-6 mb-[18px] md:p-6 space-y-4">
							<form onChange={handleChange} className="">
								<div className="flex gap-8">
									<div className="flex-auto">
										<div className="grid md:grid-cols-2 md:gap-6">
											<div className="relative z-0 w-full mb-5 group">
												<label
													for="release_date"
													className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
													Release Date
												</label>
												<DatePicker
													placeholder=" "
													id="release_date"
													name="release_date"
													selected={releaseDate}
													onChange={(date) => setReleaseDate(date)}></DatePicker>
											</div>
											<div className="relative z-0 w-full mb-5 group">
												<input
													type="text"
													pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
													name="release_id"
													id="release_id"
													className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
													placeholder=" "
													required
												/>
												<label
													for="release_id"
													className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
													Release Id
												</label>
											</div>
										</div>
										<div className="grid md:grid-cols-2 md:gap-6">
											<div className="relative z-0 w-full mb-5 group">
												<ReactSearchAutocomplete
													className="auto-complete"
													items={songItems}
													onClear={handleOnClearSong}
													onSearch={handleOnSearchSong}
													onSelect={handleOnSelectSong}
													autoFocus
													formatResult={formatResultsSong}
													showIcon={false}
													styling={{
														height: "42px",
														borderBottom: "1px solid black",
														borderRadius: "0px",
														background: "transparent",
														boxShadow: "none",
														hoverBackgroundColor: "#eee",
														color: "white",
														fontSize: ".875rem",
														fontFamily:
															'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
														iconColor: "grey",
														lineColor: "rgb(232, 234, 237)",
														placeholderColor: "grey",
														clearIconMargin: "3px 14px 0 0",
														searchIconMargin: "0 0 0 16px"
													}}
												/>
												{/* <input
													type="text"
													name="song"
													id="song"
													className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
													placeholder=" "
													required
												/> */}
												<label
													for="song"
													className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
													Song
												</label>
											</div>
											<div className="relative z-0 w-full mb-5 group">
												<ReactSearchAutocomplete
													className="auto-complete"
													items={labelItems}
													onClear={handleOnClearLabel}
													onSearch={handleOnSearchLabel}
													onSelect={handleOnSelectLabel}
													autoFocus
													formatResult={formatResultsLabel}
													showIcon={false}
													styling={{
														height: "42px",
														borderBottom: "1px solid black",
														borderRadius: "0px",
														background: "transparent",
														boxShadow: "none",
														hoverBackgroundColor: "#eee",
														color: "white",
														fontSize: ".875rem",
														fontFamily:
															'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
														iconColor: "grey",
														lineColor: "rgb(232, 234, 237)",
														placeholderColor: "grey",
														clearIconMargin: "3px 14px 0 0",
														searchIconMargin: "0 0 0 16px"
													}}
												/>
												<label
													for="label"
													className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
													Label
												</label>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
						<div className="modal-footer justify-end flex items-center p-4 md:p-5 space-x-3 rtl:space-x-reverse border-t border-gray-200 rounded-b dark:border-gray-600">
							<div className="modal-footer>">
								<button
									onClick={handleClose}
									type="button"
									className="py-2.5 px-5 text-sm font-normal text-gray-600 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
									Cancel
								</button>
								<button
									onClick={handleSubmit}
									type="button"
									className="ml-2 py-2.5 px-5 text-sm font-semibold text-gray-400 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
									Save
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<script src="https://cdn.jsdelivr.net/npm/flowbite@3.1.2/dist/flowbite.min.js"></script>
		</div>
	);
};

export default FormModal;
